const headerData = [{
		types: "selection",
		columnwidth: 50,
		fixed: 'left'
	}, {
		prop: "id",
		label: "序号",
		columnwidth: 50,
	}, {
		prop: "StatusName",
		label: "状态",
		columnwidth: 80,
	},
	{
		prop: "HPName",
		label: "医院",
		columnwidth: 150,
	},
	{
		prop: "InvNames",
		label: "产品名称",
		columnwidth: 150,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "MFName",
		label: "生产厂商",
		columnwidth: 80,
	},
	{
		prop: "SampleTypeName",
		label: "样品类型",
		columnwidth: 160,
	},
	{
		prop: "Purpose",
		label: "用途",
		columnwidth: 100,
	},
	{
		prop: "DeliveryAddress",
		label: "收货地址",
		columnwidth: 100,
	},
	{
		prop: "AreaRatioThd",
		label: "小区占比",
		columnwidth: 100,
	},
	{
		prop: "RegionRatioThd",
		label: "大区占比",
		columnwidth: 100,
	},
	{
		prop: "CountryRatioThd",
		label: "全国占比",
		columnwidth: 100,
	},
	{
		prop: "SalerInChargeName",
		label: "负责销售",
		columnwidth: 100,
	},
	{
		prop: "AdvTypeName",
		label: "分类",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "经销商",
		columnwidth: 150,
	},
	{
		prop: "ExpressCode",
		label: "单号",
		columnwidth: 150,
	},
	{
		prop: "BackFillRemark",
		label: "备注",
		columnwidth: 150,
	},
	{
		prop: "ApplyCode",
		label: "申请单号",
		columnwidth: 130,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 130,
	},
	{
		prop: "SubmitterName",
		label: "提交人",
		columnwidth: 130,
	},
	{
		prop: "SubmitTime",
		label: "提交时间",
		columnwidth: 130,
	},
	{
		prop: "RejecterName",
		label: "驳回人",
		columnwidth: 130,
	},
	{
		prop: "RejectTime",
		label: "驳回时间",
		columnwidth: 130,
	},
	{
		prop: "RejectReason",
		label: "驳回原因",
		columnwidth: 130,
	},
	{
		prop: "CanUpload",
		label: "使用反馈",
		columnwidth: 80,
		fixed: 'right'
	},
	{
		prop: "CanConfirm",
		label: "操作",
		columnwidth: 80,
		fixed: 'right'
	}
];
export default headerData;